<template>
    <div v-loading="loading">
        <div class="card card-custom card-stretch gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <i class="flaticon2-delivery-package text-primary"></i>
                    </span>
                    <h3 class="card-label">ダッシュボード</h3>
                </div>
            </div>
            <div class="card-body">
               <h1>content</h1>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from "@/core/services/api.service";

export default {
    data() {
        return {
            listMaintain: [],
            listBug: [],
            loading: false
        }
    },
    created() {
    },
    methods: {
        getListNotification() {
            this.loading = true
            apiService.get(`notification/dashboard`).then(data => {
                this.loading = false
                if (data && data.data && data.data.code === 200) {
                    this.listMaintain = data.data.data.listMaintain
                    this.listBug = data.data.data.listBug
                } else {
                    this.notifyError(data.data.message)
                }
            }).catch(e => {
                this.loading = false
                this.notifyError(e)
            })
        },
        subStr(str) {
            let number = window.innerWidth > 1920 ? 120 : 330
            let limit = Math.floor((window.innerWidth - (number + 50)*2)/31);
            let length = str.length;
            return length > limit ? str.substring(0, limit) + '...' : str;
        },
        replaceBreaksLine(str){
            return (str.replace(/\r\n|\r|\n/g,"</br>"));
        }
    }
};
</script>
<style scoped>
.el-collapse-item__arrow {
    display: none;
}
</style>

<style scoped>
.col-style {
    border: 1px solid #EBEEF5;
    padding: 10px;
    margin: 5px
}
.el-collapse-item__header.is-active .header-icon.el-icon-circle-plus{
    display: none;
}
.el-collapse-item__header.is-active .header-icon.el-icon-remove {
    display: inline-block;
}
.el-collapse-item__header .header-icon.el-icon-remove {
    display: none;
}
.el-collapse-item__header .header-icon.el-icon-circle-plus {
    display: inline-block;
}

</style>
